import { Component, Input, OnInit } from '@angular/core';
import { GridCell } from '../../../models/sections-model';

@Component({
  selector: 'kw-product-reviews',
  templateUrl: './product-reviews.component.html',
  styleUrls: ['./product-reviews.component.scss']
})
export class ProductReviewsComponent implements OnInit {
  @Input() gridCell:GridCell;
  constructor() { }

  ngOnInit(): void {
  }

}
